import { get } from 'lodash';
import React from 'react';
import formatPrice from 'services/helpers/formatPrice';

const FeeField = (props) => {
  const { record } = props;

  const stripeFee = get(record ?? {}, 'details.stripeFee');
  const transactions = get(record ?? {}, 'transactions');

  if (stripeFee && transactions?.length) {
    const currency = transactions[0].amount.currency;
    return <span>{formatPrice(stripeFee, { currency })}</span>;
  }

  const LabelTransactiondata = (transactions ?? []).filter((t) => t.description === 'Rollo label');

  if (
    LabelTransactiondata.length &&
    LabelTransactiondata[0].amount &&
    LabelTransactiondata[0].amount.currency !== 'LABEL'
  ) {
    return (
      <span>
        {formatPrice(LabelTransactiondata[0].amount.amount, {
          currency: LabelTransactiondata[0].amount.currency,
        })}
      </span>
    );
  }

  return <span>-</span>;
};

export default FeeField;
